import React from "react";

export const CashbackContext = React.createContext({
    parent: null,
});